import styles from "./QuickReplyButtons.module.css";
import type { QuickReplyOption } from "@/common/types/chat.types";

interface QuickReplyButtonsProps {
  options: QuickReplyOption[];
  onSelect: (selected: string) => void;
}

const QuickReplyButtons = ({ options, onSelect }: QuickReplyButtonsProps) => {
  return (
    <div className={styles.container}>
      {options.map((option, index) => (
        <button
          key={index}
          className={styles.button}
          onClick={() => onSelect(option.value || option.title)}
        >
          {option.title}
        </button>
      ))}
    </div>
  );
};

export default QuickReplyButtons;
